export default "__VITE_ASSET__7JTNwJTl__"